import { useState, useEffect } from 'react';
import api from '../services/api';

export default function AtividadeCustos({ atividadeId, onUpdate }) {
  const [aberto, setAberto] = useState(false);
  const [custos, setCustos] = useState([]);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({
    servico: '', valor: '', data_despesa: '', local: '',
    pago_por: '', observacao: '', cobrado_cliente: false,
    data_cobranca: '', reembolsado: false
  });

  useEffect(() => {
    if (aberto) carregar();
  }, [aberto, atividadeId]);

  async function carregar() {
    const res = await api.get(`/atividades/${atividadeId}/custos`);
    setCustos(res.data);
    if (onUpdate) onUpdate();
  }

  async function salvar() {
    if (!form.servico.trim()) { alert('Serviço é obrigatório!'); return; }
    if (!form.valor) { alert('Valor é obrigatório!'); return; }
    if (!form.data_despesa) { alert('Data é obrigatória!'); return; }
    const dados = {
      ...form,
      valor: parseFloat(form.valor),
      data_cobranca: form.data_cobranca || null,
    };
    if (editando) {
      await api.put(`/atividades/${atividadeId}/custos/${editando}`, dados);
    } else {
      await api.post(`/atividades/${atividadeId}/custos`, dados);
    }
    resetForm();
    carregar();
  }

  async function deletar(id) {
    if (!window.confirm('Remover este custo?')) return;
    await api.delete(`/atividades/${atividadeId}/custos/${id}`);
    carregar();
  }

  function editar(c) {
    setForm({
      servico: c.servico || '', valor: c.valor || '',
      data_despesa: c.data_despesa || '', local: c.local || '',
      pago_por: c.pago_por || '', observacao: c.observacao || '',
      cobrado_cliente: c.cobrado_cliente || false,
      data_cobranca: c.data_cobranca || '', reembolsado: c.reembolsado || false,
    });
    setEditando(c.id);
    setMostrarForm(true);
  }

  function resetForm() {
    setForm({ servico: '', valor: '', data_despesa: '', local: '', pago_por: '', observacao: '', cobrado_cliente: false, data_cobranca: '', reembolsado: false });
    setEditando(null);
    setMostrarForm(false);
  }

  function formatarData(dt) {
    if (!dt) return '—';
    return new Date(dt + 'T12:00:00').toLocaleDateString('pt-BR');
  }

  const total = custos.reduce((acc, c) => acc + parseFloat(c.valor || 0), 0);

  const inputStyle = { padding: '7px 10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '13px', width: '100%', boxSizing: 'border-box' };
  const labelStyle = { fontSize: '11px', color: '#555', marginBottom: '3px', display: 'block' };

  return (
    <>
      <button
        type="button"
        style={{ marginLeft: '8px', backgroundColor: 'transparent', color: '#1976d2', border: '1px solid #1976d2', padding: '1px 8px', borderRadius: '4px', fontSize: '10px', cursor: 'pointer' }}
        onClick={() => setAberto(true)}
      >
        detalhes
      </button>

      {aberto && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '1.5rem', width: '700px', maxWidth: '95vw', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '15px', fontWeight: '600', color: '#1a1a2e' }}>💰 Custas</span>
                {custos.length > 0 && (
                  <span style={{ fontSize: '13px', color: '#e53935', fontWeight: '500' }}>
                    Total: R$ {total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </span>
                )}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  style={{ backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }}
                  onClick={() => { setMostrarForm(!mostrarForm); setEditando(null); resetForm(); setMostrarForm(true); }}
                >
                  + Adicionar
                </button>
                <button
                  style={{ backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '6px 14px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }}
                  onClick={() => { setAberto(false); resetForm(); }}
                >
                  Fechar
                </button>
              </div>
            </div>

            {mostrarForm && (
              <div style={{ backgroundColor: '#f9f9f9', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '1rem', marginBottom: '1rem' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={labelStyle}>Serviço *</label>
                    <input style={inputStyle} value={form.servico} onChange={e => setForm({ ...form, servico: e.target.value })} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={labelStyle}>Valor *</label>
                    <input style={inputStyle} type="number" min="0" step="0.01" value={form.valor} onChange={e => setForm({ ...form, valor: e.target.value })} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={labelStyle}>Data *</label>
                    <input style={inputStyle} type="date" value={form.data_despesa} onChange={e => setForm({ ...form, data_despesa: e.target.value })} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={labelStyle}>Local</label>
                    <input style={inputStyle} value={form.local} onChange={e => setForm({ ...form, local: e.target.value })} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={labelStyle}>Pago por</label>
                    <input style={inputStyle} value={form.pago_por} onChange={e => setForm({ ...form, pago_por: e.target.value })} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={labelStyle}>Observação</label>
                    <input style={inputStyle} value={form.observacao} onChange={e => setForm({ ...form, observacao: e.target.value })} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '16px', marginBottom: '8px', alignItems: 'center' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#555', cursor: 'pointer' }}>
                    <input type="checkbox" checked={form.cobrado_cliente} onChange={e => setForm({ ...form, cobrado_cliente: e.target.checked })} />
                    Cobrado do cliente
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#555', cursor: 'pointer' }}>
                    <input type="checkbox" checked={form.reembolsado} onChange={e => setForm({ ...form, reembolsado: e.target.checked })} />
                    Reembolsado
                  </label>
                </div>
                {form.cobrado_cliente && (
                  <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '8px', maxWidth: '200px' }}>
                    <label style={labelStyle}>Data cobrança</label>
                    <input style={inputStyle} type="date" value={form.data_cobranca} onChange={e => setForm({ ...form, data_cobranca: e.target.value })} />
                  </div>
                )}
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button style={{ backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '7px 16px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }} onClick={salvar}>Salvar</button>
                  <button style={{ backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '7px 16px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }} onClick={resetForm}>Cancelar</button>
                </div>
              </div>
            )}

            {custos.length === 0 ? (
              <p style={{ fontSize: '13px', color: '#aaa', textAlign: 'center', padding: '2rem 0' }}>Nenhuma custa lançada</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {['Serviço', 'Data', 'Local', 'Pago por', 'Valor', 'Cobrado', 'Reembolsado', ''].map(h => (
                      <th key={h} style={{ padding: '8px 10px', textAlign: 'left', fontSize: '11px', color: '#888', borderBottom: '1px solid #f0f0f0', fontWeight: '500' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {custos.map(c => (
                    <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: '8px 10px', fontSize: '13px' }}>{c.servico}</td>
                      <td style={{ padding: '8px 10px', fontSize: '12px', color: '#888' }}>{formatarData(c.data_despesa)}</td>
                      <td style={{ padding: '8px 10px', fontSize: '12px' }}>{c.local || '-'}</td>
                      <td style={{ padding: '8px 10px', fontSize: '12px' }}>{c.pago_por || '-'}</td>
                      <td style={{ padding: '8px 10px', fontSize: '13px', fontWeight: '600', color: '#e53935' }}>
                        R$ {parseFloat(c.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </td>
                      <td style={{ padding: '8px 10px', fontSize: '12px' }}>
                        {c.cobrado_cliente ? <span style={{ color: '#1976d2' }}>✓</span> : <span style={{ color: '#ccc' }}>—</span>}
                      </td>
                      <td style={{ padding: '8px 10px', fontSize: '12px' }}>
                        {c.reembolsado ? <span style={{ color: '#388e3c' }}>✓</span> : <span style={{ color: '#f57c00' }}>Pendente</span>}
                      </td>
                      <td style={{ padding: '8px 10px' }}>
                        <button style={{ backgroundColor: 'transparent', color: '#1a1a2e', border: '1px solid #ddd', padding: '3px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', marginRight: '4px' }} onClick={() => editar(c)}>Editar</button>
                        <button style={{ backgroundColor: 'transparent', color: '#e53935', border: '1px solid #e53935', padding: '3px 6px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' }} onClick={() => deletar(c.id)}>✕</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </>
  );
}